import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

export const parentSchema = z.object({
  firstname: z.string().min(1),
  lastname: z.string().min(1),
  phone: z.string().optional(),
  email: z.string().email().optional().or(z.literal('')),
  city: z.string().optional(),
  cp: z.string().optional(),
})

export type ParentFormData = z.infer<typeof parentSchema>

export function useParentForm({ initialValues }: { initialValues?: ParentFormData }) {
  const rhForm = useForm<ParentFormData>({
    defaultValues: initialValues ?? {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      city: '',
      cp: '',
    },
    resolver: zodResolver(parentSchema),
  })

  return { rhForm }
}
